<div class="progress-bar-wraper" 
*ngIf="!forceHide"
[ngStyle]="{'background-color': options.backgroundColor}" 
[ngClass]="{'show': visible}">
  <div class="d-flex flex-column align-items-center">
    <p *ngIf="options.showText && status != 'error'" class="small">{{'PROGRESS_BAR.loading' | translate}}</p>
    <div *ngIf="status === 'error'" class="d-flex justify-content-center align-items-center">
      <p class="color-error small">{{'PROGRESS_BAR.errorLoading' | translate}}. {{'PROGRESS_BAR.retry' | translate}}</p>
      <onwac-button 
      [text]="'FUNNEL.refresh' | translate" 
      [type]="'icon'" 
      [icon]="'autorenew'" 
      (click)="sendRefresh()"></onwac-button>
    </div>
    <div class="progress-bar" 
    [ngClass]="{
      'start': status === 'start',
      'middle': status === 'middle',
      'end': status === 'end',
      'error': status === 'error'
    }"></div>
  </div>
</div>